import App from './App';
import './Signin.css';
import React, { useEffect, useState } from 'react';
import { auth } from './Firebase';
import SignUp from './SignUp';
import Practice from './Practice';
import NewHomework from './NewHomework';
import NewExplain from './NewExplain';
import MarketingPage from './MarketingPage';

import {
    signInWithEmailAndPassword,
    onAuthStateChanged,
    GoogleAuthProvider,
    signInWithPopup,
    sendPasswordResetEmail
} from 'firebase/auth';

function SigninApp() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [user, setUser] = useState(null);
    const [showSignUp, setShowSignUp] = useState(false);
    const [showMarketing, setShowMarketing] = useState(true);
    const [showSignIn, setShowSignIn] = useState(false);
    // Listen for authentication state changes
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
            setUser(currentUser);
            if (currentUser) {
                console.log('Signin component User is signed in:', currentUser.uid);
            }
        });
        return () => unsubscribe();
    }, []);

    const urlParams = new URLSearchParams(window.location.search);
    const homeworkParam = urlParams.get('h');
    const explainParam = urlParams.get('e');
    const practiceParam = urlParams.get('p');
    const signInParam = urlParams.get('signin');

    // Show sign-in directly if there's a signin URL parameter
    useEffect(() => {
        if (signInParam === 'true') {
            setShowSignIn(true);
        }
    }, [signInParam]);

    const handleSignInWithEmail = async () => {
        try {
            const userCredential = await signInWithEmailAndPassword(auth, email, password);
            const user = userCredential.user;
            if (!user.emailVerified) {
                await auth.signOut();
                alert('Please verify your email before signing in.');
            }
        } catch (error) {
            alert('Error signing in. ' + error.message);
            console.error('Error signing in:', error);
        }
    };

    const handleResetPassword = async () => {
        if (!email) {
            alert('Please enter your email to reset your password.');
            return;
        }
        try {
            await sendPasswordResetEmail(auth, email);
            alert('Password reset email sent! Please check your inbox.');
        } catch (error) {
            alert('Error sending password reset email. ' + error.message);
            console.error('Error sending password reset email:', error);
        }
    };

    const handleSignInWithGoogle = () => {
        const provider = new GoogleAuthProvider();
        signInWithPopup(auth, provider).catch((error) => {
            console.error('Error signing in with Google:', error);
            alert('Error signing in with Google: ' + error.message);
        });
    };

    if (practiceParam && practiceParam.length > 5) {
        return (
            <Practice sourceDocumentID={practiceParam} />
        );
    }

    if (user) {
        if (homeworkParam && homeworkParam.length > 5) {
            return (
                <NewHomework sourceDocumentID={homeworkParam} />
            );
        }
        if (explainParam && explainParam.length > 5) {
            return (
                <NewExplain sourceDocumentID={explainParam} />
            );
        }
        return (
            <App user={user} />
        );
    }

    // Show sign up component if selected
    if (showSignUp) {
        return <SignUp onBackToSignIn={() => {
            setShowSignUp(false);
            setShowSignIn(true);
            setShowMarketing(false);
        }} />;
    }
    const handleGetStarted = () => {
        setShowMarketing(false);
        setShowSignIn(true);
    };
    // Show marketing page if it's the first visit
    if (showMarketing) {
        return <MarketingPage onGetStarted={handleGetStarted} />;
    }

    // Sign-in form
    return (
        <div className="signin-container">
            <div className="signin-header">
                GenAI Tutor
            </div>

            <div className="signin-content">
                {/* Sign In Form */}
                <div className="signin-form">
                    <div className="form-title">Explore and Learn </div>

                    <input
                        className="textinput"
                        type="email"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />

                    <input
                        type="password"
                        className="textinput"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                    <br />
                    <button className="signonpagebutton" onClick={handleSignInWithEmail}>
                        Sign In
                    </button>
                    &nbsp;&nbsp;&nbsp;
                    <button className="signonpagebutton" onClick={handleResetPassword}>
                        Reset Password
                    </button>
                    <br />
                    <br />
                    <button className="signonpagebutton" onClick={handleSignInWithGoogle}>
                        Sign In with Google
                    </button>
                    <br />

                    <br />
                    <br />
                    <button className="signonpagebutton" onClick={() => setShowSignUp(true)}>
                        First time? Sign Up
                    </button>
                    <br />
                    <br />
                    <button className="signuppagebutton" onClick={() => {   setShowSignIn(false);
                        setShowMarketing(true);}}>
                        Back to Home
                    </button>

                    <div className="signin-footer">
                        <p>Need help? Contact &nbsp;&nbsp;
                            <a href="mailto:sharathck@outlook.com">
                                <span className="email-link">
                                    sharathck@outlook.com
                                </span>
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SigninApp;

